<template>
  <div class="esterno">
    <p class="titolo_oscars">Ecco la classifica dei FantaOscar 2022!</p>
    <img alt="classifica" src="../assets/Oscars/classifica.png" class="classifica" />
  </div>
</template>

<script>
export default {};
</script>

<style>
.classifica {
  /* width:"400";
  height:"400"; */
  --max-height: 600px;
  /* Set a baseline width for your element */
  width: 90%;
  /* And limit it with our function above */
  max-width: calc(var(--max-height, 300px) * var(--img-ratio, 1));
}
.titolo_oscars {
  color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 5px 5px;
  /* border: 2px solid #961313; */
  border-radius: calc(10px);
  background: #2c3e50;
  width: 80%;
  margin-left: 10%;
  padding: 1%;
  margin-top: 2%;
  margin-bottom: 1%;
  font-size: 1.5em;
}

@media screen and (min-width: 1100px) and (max-width: 1500px) {
  .modulo_google {
    width: "640px";
  }
}
@media screen and (min-width: 1000px) and (max-width: 1100px) {
  .modulo_google {
    width: "640px";
  }
}
@media screen and (min-width: 850px) and (max-width: 1000px) {
  .esterno {
    margin-top: 16%;
  }
  .modulo_google {
    width: "640px";
  }
  .titolo_oscars {
    font-size: 1.2em;
  }
}
@media screen and (max-width: 850px) and (min-width: 540px) {
  .esterno {
    margin-top: 20%;
  }
    .titolo_oscars{
    font-size: 1.2em;
  }

}
@media screen and (max-width: 540px) and (min-width: 380px) {
  .esterno {
    margin-top: 40%;
  }
    .titolo_oscars{
    font-size: 1.2em;
  }

}
@media screen and (max-width: 380px) {
  .titolo_oscars {
    font-size: 1.2em;
  }
}

</style>